module.exports = "pegasus/assets/preview.png";